export enum SearchBarId {
  HOMEPAGE = 'homepage',
  HEADER = 'header',
  SEARCH_PAGE = 'searchPage'
}
